/**
 * BIBLE BOOKS GAME LOGIC
 * ======================
 * This file now ONLY exports the unique logic and components for this game.
 * All shared configuration data has been moved to the unified config.
 */

import BibleBooksHint from '../../components/BibleBooksHint/BibleBooksHint';
import BookDirectory from '../../components/BookDirectory/BookDirectory';
import BibleBooksHowToPlay from '../../components/BibleBooksHowToPlay/BibleBooksHowToPlay';

const compareBooks = (guessed, target) => {
  const results = {};
  
  const simpleFields = ['testament', 'genre', 'author', 'audience'];
  simpleFields.forEach(field => {
    results[field] = guessed[field] === target[field] ? 'correct' : 'incorrect';
  });
  
  const guessedCount = guessed.chapter_count;
  const targetCount = target.chapter_count;
  
  if (guessedCount === targetCount) {
    results.chapter_count = 'correct';
  } else {
    results.chapter_count = guessedCount < targetCount ? 'partial-up' : 'partial-down';
  }

  return results;
};

const getDisplayValue = (book, categoryKey) => {
  const value = book[categoryKey];
  if (categoryKey === 'chapter_count') {
    return String(value);
  }
  if (value === null || typeof value === 'undefined' || String(value).trim() === '') {
    return 'None';
  }
  return String(value);
};

const bibleBooksLogic = {
  // Keep only what is unique to this game
  categories: [
    { key: 'testament', label: 'Testament' },
    { key: 'genre', label: 'Genre' },
    { key: 'author', label: 'Primary Author' },
    { key: 'chapter_count', label: 'Chapters' },
    { key: 'audience', label: 'Audience' }
  ],
  compareFunction: compareBooks,
  getDisplayValue,
  
  HintComponent: BibleBooksHint,
  DirectoryComponent: BookDirectory,
  HowToPlayComponent: BibleBooksHowToPlay,
  
  renderVictoryDetails: (book) => (
    <div className="bible-books-game__book-verse">
      <div><strong>Key Verse:</strong></div>
      <div className="bible-books-game__verse-text">"{book.verse}"</div>
    </div>
  )
};

export default bibleBooksLogic;